import React, { useEffect, useState } from "react";

import { useProductServiceApi } from "@api/hooks/productService.hook";
import {
    ProductTileMapper,
    ProductsMapper,
} from "@api/mappers/products.mapper";

import { arrayHasContent } from "@utils/array";
import { ProductFieldSet, ProductSliderSources } from "@utils/enums";
import {
    determineSlidesPerViewByObject,
    getBreakPointLayoutSettings,
} from "@utils/swiper";

import { ProductSlider } from "@components/Product/ProductSlider/productSlider.component";

import { ProductTileApiModel } from "../../../../@types/service/product/api/productTile.api.model";

type ProductSliderProps = {
    title: string;
    showButton: boolean;
    showCategoryLink: boolean;
    useInsidePadding: boolean;
    amountOfFeatures: number;
    breakpointslayoutsettings: any;
    skuList: Array<string>;
    prefetchedData?: Array<ProductTileApiModel>;
    ssrLayoutClasses?: string;
    lazyLoad: boolean;
};

type Props = ProductSliderProps & {};

const SKUProductSlider = ({
    title,
    showButton,
    amountOfFeatures,
    showCategoryLink,
    useInsidePadding,
    breakpointslayoutsettings,
    skuList,
    prefetchedData,
    ssrLayoutClasses,
    lazyLoad,
}: Props) => {
    const [products, setProducts] = useState(
        ProductsMapper(ProductTileMapper)({ entities: prefetchedData || [] }),
    );

    const [{}, loadProducts] = useProductServiceApi(
        {
            url: `/products`,
            method: "GET",
            mapper: ProductsMapper(ProductTileMapper),
        },
        {
            manual: true,
            useCache: false,
            autoCancel: false,
        },
    );

    useEffect(() => {
        if (!prefetchedData) {
            getProductData(skuList);
        }
    }, [skuList]);

    const getProductData = (skuList: Array<string>) => {
        if (skuList && skuList.length > 0) {
            loadProducts({
                params: {
                    sku: skuList.join(","),
                    fields: ProductFieldSet.ProductTile,
                },
            }).then(({ data }) => {
                setProducts(data);
            });
        }
    };

    if (!arrayHasContent(products)) {
        return null;
    }

    return (
        <ProductSlider
            title={title}
            lazyLoad={lazyLoad}
            products={products}
            productsource={ProductSliderSources.accessory}
            showButton={showButton}
            amountOfFeatures={amountOfFeatures}
            showCategoryLink={showCategoryLink}
            useInsidePadding={useInsidePadding}
            breakpointslayoutsettings={determineSlidesPerViewByObject(
                getBreakPointLayoutSettings(breakpointslayoutsettings),
            )}
            ssrLayoutClasses={ssrLayoutClasses}
            analyticsContext={{
                list: "product-slider-sku",
                listTitle: title,
            }}
        />
    );
};

export { SKUProductSlider };
